<template>
  <div v-if="pageDevice != null && typeof(pageDevice.config) != 'undefined' && isLoginUserPageItemWritable">

    <deviceTabs v-if="isLoginUserPageItemReadable" :current="'config'" :pageDevice="pageDevice" :pageUser="pageUser">
      <b-button v-if="!pageDevice.disabled" :disabled="!pageBinded || pageDevice.disabled" @click="saveDeviceConfig"  size="sm" class="displayNoneMax589 float-right tabButton" variant="danger">
        <b-spinner small type="grow" class="mr-1" v-if="showSaveSpinner"></b-spinner>
        설정 저장하기
      </b-button>
      <b-button v-if="!pageDevice.disabled" v-b-modal.configJsonFloat :disabled="!pageBinded || pageDevice.disabled" size="sm" class="displayNoneMax777 float-right tabButton mr-2" variant="secondary">
        설정 다운로드
      </b-button>
    </deviceTabs>

    <div :class="(isLoginUserPageItemWritable)? 'writable':'notWritable'">
      <div v-if="isLoginUserPageItemWritable">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="this.pageDevice.disabled">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>
      <b-form @submit.stop.prevent class="was-validated" id="formData">

        <h4 class="border-bottom mt-3 pt-1 pb-1">
          설정 정보
        </h4>

        <b-input-group size="sm" class="mt-3" v-if="typeof(pageDevice.config.ve) != 'undefined'">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="ve" style="margin-bottom : 0rem">설정 버전</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop readonly id="ve" disabled v-model="pageDevice.config.ve" type="number" :number="true"/>
          <b-button variant="secondary" class="pl-2 pr2" v-b-tooltip.hover.left title="설정의 현재 버전입니다. data.tinkable.net에서 설정을 저장하면 이 값보다 큰 짝수로 버전이 올라갑니다. 기기의 설정 버전이 서버의 설정 버전보다 낮으면 기기가 켜질 때 서버의 설정 버전이 적용됩니다." slot="append">?</b-button>
        </b-input-group>


        <h4 class="border-bottom mt-3 pt-1 pb-1">
          WiFi 설정
        </h4>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="ss" style="margin-bottom : 0rem">WiFi 이름</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.ss" id="ss" v-on:keyup="enterKeyChecker" data-nextfocus="pw" maxlength="32" minlength="1" pattern='^[^!#;+\]\/"\t][^+\]\/"\t ]{0,30}[^ !#;+\]\/"\t]$|^[^ !#;+\]\/"\t]$' v-b-tooltip.focus title='연결할 Wifi의 이름(SSID). 32글자까지 가능. 영문 대소문자, 숫자, _, - 등 일부 기호만 사용 가능하며, 한글, 공백문자, ?, ", $, [, \, ], +는 사용할 수 없습니다.' trim :disabled="!isLoginUserPageUser"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="pw" style="margin-bottom : 0rem">패스워드</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.pw" id="pw" v-b-tooltip.focus title="WiFi 이름이나 WiFi ID의 패스워드. 최대 32 글자." v-on:keyup="enterKeyChecker" data-nextfocus="wifiId" maxlength="32" minlength="2" trim :disabled="!isLoginUserPageUser"/>
        </b-input-group>

        <!--b-input-group size="sm" class="mt-1" disabled="disabled">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="wifiId" style="margin-bottom : 0rem">ID</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.id" id="wifiId" v-b-tooltip.focus title="[개발중/사용금지] WiFi ID. 최대 32 글자. WEP Enterprise 연결에서 사용하며 아직 지원하지 못하고 있습니다." v-on:keyup="enterKeyChecker" data-nextfocus="wt" maxlength="32" minlength="2" trim :disabled="!isLoginUserPageUser||true"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="wt" style="margin-bottom : 0rem">WiFi 보안 종류</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.config.wt" id="wt" :disabled="!isLoginUserPageUser||true" required v-b-tooltip.focus title="[개발중/사용금지] WiFi 연결에 사용하는 보안 방식. WEP, WPA Personal, WPA Enterprise 중에 선택할 수 있습니다. 기본값은 WPA Personal입니다. WEP는 너무 약한 보안 방식이라서 요즘 거의 사용하지 않고 있습니다. 대부분의 공유기는 WPA Personal입니다. 최근에는 보안을 강화한 WPA Enterprise를 사용하는 곳도 있으며 이 경우에는 WiFi 이름(SSID) 외에도 인증 ID, 인증 패스워드를 사용합니다. Tinkable IoT Core는 아직 WPA Enterprise를 지원하지 않습니다. 장기적으로 WPA Enterprise에서 인증서 혹은 인증 파일을 사용하여 인증하는 방식은 계속 지원하지 않을 것이며, 현재 WPA Enterprise-Radius ID와 패스워드 인증-PEAP+MSCHAPv2를 지원하기 위해서 개발 중에 있습니다.">
            <option :value="2">WEP</option>
            <option :value="3">WPA Personal</option>
            <option :value="4">WPA Enterprise</option>
          </b-form-select>
        </b-input-group-->

        <div class="mt-1 gothic gridColumn" v-if="pageDevice.wifi">
          <div class="gridColumnTitle pt-3">멀티 Wifi 설정</div>
          <div class="gridColumnBody">

            <b-list-group size="sm">

              <b-list-group-item class="pl-2 pr-2 pt-2 pb-1 lineHeight130" v-if="pageDevice.wifi.length != 0">

                <span v-for="(item, index) of pageDevice.wifi" :key="item.s" class="fontSizeDot9 d-inline-block border border-gray p-1 pt-dot1 pb-dot2 mr-1 mb-1">

                  <span class="pl-1 pr-1 align-middle">
                    WiFi 이름:
                  </span>

                  <span class="align-middle font-weight-bold">
                    {{ item.s }}
                  </span>

                  <span class="pl-1 pr-1 align-middle">
                    패스워드:
                  </span>

                  <span class="align-middle font-weight-bold">
                    {{ item.p }}
                  </span>

                  <b-button slot="append" class="fontSizeDot8  border-secondary round-0 ml-1 mr-1 pl-1 pr-1 pt-0 pb-0" variant="outline-dark" size="sm" v-on:click="deleteSSID(index)">X</b-button>
                </span>

              </b-list-group-item>

              <b-list-group-item class="p-1" :key="'-1'">
                <b-input-group size="sm">
                  <b-input-group-text class="fontSizeDot8 lineHeight100 rounded-0 displayNoneMax589">
                    WiFi 이름
                  </b-input-group-text>
                  <b-form-input v-touch:swipe.stop type="text" trim v-model="wifiNewSSID" id="wifiNewSSID" maxlength="32" minlength="1" size="sm" pattern='^[^!#;+\]\/"\t][^+\]\/"\t]{0,30}[^ !#;+\]\/"\t]$|^[^ !#;+\]\/"\t]$' v-b-tooltip.focus title='연결할 Wifi의 이름(SSID). 32글자까지 가능. 영문 대소문자, 숫자, _, - 등 일부 기호만 사용 가능하며, 한글, 공백문자, ?, ", $, [, \, ], +는 사용할 수 없습니다.'/>

                  <b-input-group-text class="fontSizeDot8 lineHeight100 rounded-0 displayNoneMax589">
                    패스워드
                  </b-input-group-text>
                  <b-form-input  v-touch:swipe.stop type="text" trim v-model="wifiNewPassword" maxlength="32" minlength="1" v-b-tooltip.focus title="연결할 Wifi의 패스워드. 32글자까지 가능."/>

                  <b-button slot="append" :disabled="this.wifiNewSSID.length == 0 || this.pageDevice.wifi.length > 20" class="fontSizeDot8" variant="primary" size="sm" @click="addNewSSID()">추가</b-button>
                </b-input-group>
              </b-list-group-item>

            </b-list-group>

          </div>
        </div>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="wi" style="margin-bottom : 0rem">WIFI 확인 간격</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.wi" id="wi" v-b-tooltip.focus title="WiFi가 끊어진 경우 WiFi 접속을 다시 시도할 간격을 1/1000초 단위로 지정합니다. 최소값은 60000(1분)이며 최대값은 86400000(1일)입니다. 팅커블 IoT 키트는 WiFi 연결을 시도하는 동안 버튼 입력이 되지 않고 센서 측정도 하지 않으므로 이 간격을 너무 짧게 하면 불편합니다." v-on:keyup="enterKeyChecker" data-nextfocus="ui" min="60000" max="86400000" type="number" :number="true" trim :disabled="!isLoginUserPageUser"/>
        </b-input-group>


        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="ip" style="margin-bottom : 0rem">IP 주소</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.ip" id="ip" v-b-tooltip.focus title="팅커블 IoT 키트가 WiFi에 연결될 때 사용할 IP 주소입니다. 거의 모든 WiFi 라우터(혹은 공유기)에서 DHCP를 지원하므로 일반적인 경우 IP 주소를 설정할 필요는 없습니다. IP 주소를 지정하면 WiFi 연결에 걸리는 시간과 배터리 사용량을 줄일 수 있습니다."
          v-on:keyup="enterKeyChecker" data-nextfocus="sm" trim :disabled="!isLoginUserPageUser" pattern="^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="sm" style="margin-bottom : 0rem">서브넷 마스크</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.sm" id="sm" v-b-tooltip.focus title="팅커블 IoT 키트가 WiFi에 연결될 때 사용할 서브넷 마스크입니다. 거의 모든 WiFi 라우터(혹은 공유기)에서 DHCP를 지원하므로 일반적인 경우 서브넷 마스크를 설정할 필요는 없습니다. IP 주소를 지정하면 WiFi 연결에 걸리는 시간과 배터리 사용량을 줄일 수 있습니다."
          v-on:keyup="enterKeyChecker" data-nextfocus="ga" trim :disabled="!isLoginUserPageUser" pattern="^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="ga" style="margin-bottom : 0rem">게이트웨이 주소</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.ga" id="ga" v-b-tooltip.focus title="팅커블 IoT 키트가 WiFi에 연결될 때 사용할 게이트웨이 주소입니다. 거의 모든 WiFi 라우터(혹은 공유기)에서 DHCP를 지원하므로 일반적인 경우 게이트웨이 주소를 설정할 필요는 없습니다. IP 주소를 지정하면 WiFi 연결에 걸리는 시간과 배터리 사용량을 줄일 수 있습니다."
          v-on:keyup="enterKeyChecker" data-nextfocus="dn" trim :disabled="!isLoginUserPageUser" pattern="^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="dn" style="margin-bottom : 0rem">DNS 서버 주소</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.dn" id="dn" v-b-tooltip.focus title="팅커블 IoT 키트가 WiFi에 연결될 때 사용할 DNS 서버의 IP 주소입니다. 지정하지 않으면 WiFi 라우터(혹은 공유기)에 설정된 DNS 서버의 IP 주소를 사용하므로 일반적인 경우 DNS 서버의 주소를 설정할 필요는 없습니다. DNS 서버의 IP 주소를 지정한 경우에 두번째 DNS 서버의 IP 주소로는 구글 DNS 서버인 8.8.8.8을 사용합니다."
          v-on:keyup="enterKeyChecker" data-nextfocus="sm" trim :disabled="!isLoginUserPageUser" pattern="^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$"/>
        </b-input-group>

        <h4 class="border-bottom mt-3 pt-1 pb-1">
          업데이트와 재부팅
        </h4>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="ui" style="margin-bottom : 0rem">업데이트 간격</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.ui" id="ui" v-b-tooltip.focus v-on:keyup="enterKeyChecker" data-nextfocus="sr" min="60000" max="86400000" type="number" :number="true" trim :disabled="!isLoginUserPageUser" title="측정한 데이터를 서버로 전송하는 간격의 기본값을 1/1000초 단위로 지정합니다. 최소값은 60000(1분)이며 최대값은 86400000(1일)입니다. 센서 설정에서 센서마다 따로 전송 간격을 지정할 수 있고, SLEEP 모드를 제외하고 센서에 지정한 전송 간격이 우선합니다. 팅커블 IoT 키트는 데이터를 서버로 전송하는 동안 버튼 입력이 되지 않고 센서 측정도 하지 않으므로 이 간격을 너무 짧게 하면 불편합니다. 가능한 120000(2분)이상으로 설정하세요. SLEEP 모드에서는 Config Sleep Save, Config Sleep Update, Sleep Interval 설정과 함께 사용하여 지정한 시간에 지정한 간격으로 데이터를 서버에 전송할 수 있습니다. 예를 들어 Config Sleep Save 설정으로 토요일 3시대에 데이터를 저장하도록 설정하고 Sleep Interval 설정을 900000(15분)으로 지정하면 토요일 3시 0분, 3시 15분, 3시 30분, 3시 45분에 센서 데이터를 읽어서 저장합니다. 이 때 Config Sleep Update 속성으로 토요일 3시 대에 데이터를 서버로 전송하도록 설정하고 Sleep Update 설정을 2700000(45분)으로 지정하면, 토요일 3시 45분에 지금까지 측정하여 저장된 데이터를 서버로 전송합니다. 0보다 크고 3600000(60분)보다 작은 Sleep Interval 설정의 배수 중에 Sleep Update 속성으로 나누어서 나머지가 0인 경우에 서버로 데이터를 전송합니다."/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="rb" style="margin-bottom : 0rem">재부팅 시간 설정</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop readonly id="rb" :placeholder="configRebootBinary"/>
          <b-button id="rbbtn" slot="append" variant="primary" class="rightTultip p-1 pr-2 pl-2" v-b-tooltip.hover.left title="특정한 요일, 특정한 시간에 기기를 자동으로 리부팅하도록 설정합니다. 기기가 켜지고 30분이 지난 뒤부터 동작합니다." v-b-modal.configRebootFloat data-nextfocus="slbtn">설정</b-button>
        </b-input-group>

        <h4 class="border-bottom mt-3 pt-1 pb-1">
          SLEEP 기능
        </h4>


        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="si" style="margin-bottom : 0rem">SLEEP 간격</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.si" id="si" v-b-tooltip.focus title="SLEEP 모드로 동작하는 경우에 켜지는 간격입니다. 단위는 1/1000초입니다. 기기의 SLEEP 실제 시간은 지정한 값보다 3~7% 짧습니다. 팅커블 IoT 키트는 최근 5번의 SLEEP 시간과 실제 SLEEP 시간 데이터를 비교하여 적절한 SLEEP 시간으로 보정하여 동작합니다. 최소값은 300000(5분)이며 최대값은 10800000(3시간)입니다.  기기에서 해당 간격으로 다음 읽기 시간을 저장하므로 읽기 간격은 정확하게 동작합니다. 그리고 SLEEP 간격이 60000(1분)의 배수인 경우에는 센서 데이터 읽는 시간은 항상 0초입니다." v-on:keyup="enterKeyChecker" data-nextfocus="rbbtn" min="10000" max="1800000" type="number" :number="true" trim :disabled="!isLoginUserPageUser"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="sr" style="margin-bottom : 0rem">SLEEP 읽기 지연 시간</label>
          </b-input-group-text>
          <b-form-input
          v-model="pageDevice.config.sr" id="sr" v-b-tooltip.focus title="SLEEP 모드로 동작하는 경우에 기기는 이 값으로 지정한 시간만큼 미리 부팅하여 읽기를 준비합니다. 단위는 1/1000초입니다. 최소값은 10000(10초)이며 최대값은 1800000(10분)입니다. SLEEP은 지정한 값보다 크게 보정된 값으로 동작하지만 실제 SLEEP 시간은 SLEEP 간격보다 짧아서 기기는 SLEEP 읽기 지연 시간 + SLEEP 오차 시간만큼 일찍 부팅하여 읽기를 준비합니다. SLEEP 읽기 지연이 너무 짧으면 SLEEP 오차 시간의 변화가 아주 큰 경우에 해당 시간에 데이터를 측정못할 수 있고, 이 값을 너무 크게 지정하면 팅커블 IoT 키트가 켜져 있는 시간이 길어져 배터리 소모가 늘어납니다. 기본값은 30000(30초)입니다." v-on:keyup="enterKeyChecker" data-nextfocus="si" min="10000" max="86400000" type="number" :number="true" trim :disabled="!isLoginUserPageUser"/>
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="sl" style="margin-bottom : 0rem">SLEEP 읽기 시간</label>
          </b-input-group-text>
          <b-form-input  v-touch:swipe.stop readonly id="sl" :placeholder="configSleepSaveBinary"/>
          <b-button id="slbtn" slot="append" variant="primary" class="rightTultip p-1 pr-2 pl-2" v-b-tooltip.hover.left title="특정한 요일, 특정한 시간에 센서 데이터를 측정하여 저장합니다. SLEEP 읽기 시간 설정으로 요일과 시간을 지정한 경우에 SLEEP 간격 속성은 그 시간에서 읽는 간격으로 동작합니다. 예를 들어 SLEEP 읽기 시간 설정으로 토요일 3시를 켜고 SLEEP 간격 설정이 900000(15분)이면 토요일 3시 0분, 3시 15분, 3시 30분, 3시 45분에 센서 데이터를 읽어서 저장합니다. SLEEP 업데이트 시간 설정을 끈 경우에는 업데이트 간격이 SLEEP 간격보다 작으면 센서 데이터를 읽은 후에 항상 서버로 업데이트하나 업데이트 간격이 SLEEP 간격보다 크면 업데이트 간격/SLEEP 간격을 내림한 값만큼 읽기가 이루어지면 서버로 업데이트합니다. SLEEP 간격 설정이 600000(10분)이고 업데이트 간격이 1800000(30분)이면 3번 읽은 데이터를 저장해두었다가 한꺼번에 서버로 업데이트합니다." v-b-modal.configSleepSaveFloat nextfocus="subtn">설정</b-button>
        </b-input-group>


        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="su" style="margin-bottom : 0rem">SLEEP 업데이트 시간</label>
          </b-input-group-text>

          <b-form-input v-touch:swipe.stop readonly id="su" :placeholder="configSleepUpdateBinary"/>

          <b-button id="subtn" slot="append" variant="primary" class="rightTultip p-1 pr-2 pl-2" v-b-tooltip.hover.left title="SLEEP 모드에서 특정한 요일, 특정한 시간에 측정한 데이터를 서버로 업로딩하도록 설정합니다. 동일한 요일, 시간대의 SLEEP 저장 시간 설정과 SLEEP 업데이트 시간 설정이 모두 켜진 경우에만 데이터 업데이트를 합니다.

          예를 들어 SLEEP 저장 시간 설정으로 토요일 3시대에 데이터를 저장하도록 설정하고 SLEEP 간격 설정을 900000(15분)으로 지정하면 토요일 3시 0분, 3시 15분, 3시 30분, 3시 45분에 센서 데이터를 읽어서 저장합니다. 이 때 SLEEP 업데이트 시간 설정으로 토요일 3시 대에 데이터를 서버로 전송하도록 설정하고 업데이트 간격 설정을 2700000(45분)으로 지정하면 토요일 3시 0분, 토요일 3시 45분에 지금까지 저장한 데이터가 업데이트 됩니다. SLEEP 업데이트 시간 설정이 SLEEP 간격 설정과 같은 경우에는 저장과 업데이트를 동시에 합니다." v-b-modal.configSleepUpdateFloat nextfocus="ip">설정</b-button>

        </b-input-group>

        <h4 class="border-bottom mt-3 pt-1 pb-1">
          상세 설정
        </h4>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="st" style="margin-bottom : 0rem">이진 설정값</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop readonly id="st" :value="configStatusBinary"/>
          <b-button variant="secondary" slot="append" size="sm" class="pl-2 pr-2" v-b-tooltip.hover
          title="여러가지 설정이 합쳐진 이진값입니다. 사용, 사용안함 값을 가진 여러가지 설정은 합쳐져서 하나의 값으로 변환되어 기기로 전송됩니다.">?</b-button>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-for="(item, index) in configStatusInputList" :key="index">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label :for="item.id" style="margin-bottom : 0rem">{{item.title}} [{{item.pos+1}}]</label>
          </b-input-group-text>
          <b-form-select v-model="item.value" :id="item.id" :disabled="!isLoginUserPageItemWritable || item.disabled === true" required v-b-tooltip.focus :title="item.details" size="sm">
            <option :value="0">사용안함(0)</option>
            <option :value="1">사용(1)</option>
          </b-form-select>
        </b-input-group>

        <div class="mt-3 text-left" v-if="isLoginUserPageItemWritable">
          <b-button variant="outline-dark" class="mr-1 mt-1" v-if="!pageDevice.disabled" size="sm" @click="resetDeviceConfig">
            기기설정 초기화하기
          </b-button>

          <b-button v-if="!pageDevice.disabled" variant="danger" :disabled="!pageBinded || pageDevice.disabled" @click="saveDeviceConfig" size="sm" class="float-right mr-1 mt-1">
            <b-spinner small type="grow" class="mr-1" v-if="showSaveSpinner"></b-spinner>
            기기설정 저장하기
          </b-button>

          <b-button v-if="!pageDevice.disabled" variant="secondary" :disabled="!pageBinded || pageDevice.disabled" v-b-modal.configJsonFloat size="sm" class="float-right mr-1 mt-1">
            기기설정파일 다운로드
          </b-button>
        </div>
      </b-form>
    </div>

    <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configJsonFloat"
      tabindex="-1" title="기기설정파일 보기" static @show="modalShowFocus" data-nextfocus="saveDeviceConfigButton" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
        <b-textarea size="sm" rows="15" class="fontSizeDot9" v-model="configJsonSource" readonly></b-textarea>
      <template slot="modal-footer">

        <b-button variant="primary" id="saveDeviceConfigButton" size="sm" @click="createConfigJson" v-b-tooltip.hover title="다운로드 할 기기설정파일을 만듭니다.">
          다운로드 할 기기설정파일 만들기
        </b-button>
        <b-button v-if="configJsonDownloadURL != null" variant="danger" size="sm" :href="configJsonDownloadURL" download="config.json" v-b-tooltip.hover title="만든 기기설정파일을 다운로드 합니다.">
          만든 기기설정파일 다운로드
        </b-button>
        <b-button variant="secondary" size="sm" @click="hideModal('configJsonFloat')">
          닫기
        </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configRebootFloat"
      tabindex="-1" title="자동 리부팅(Config Reboot) 설정" static
      @show="modalShowFocus" data-nextfocus="configRebootUse" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

      <p class="mb-1 fontSizeDot9 gothic">
        특정 요일, 시간에 기기를 자동으로 껐다 켤 수 있습니다. 일주일에 한번 정도 기기를 리부팅하면 시스템을 건강한 상태로 유지할 수 있습니다.
      </p>

      <b-form @submit.stop.prevent class="m-3">

        <b-form-group class="mb-3">
          <b-form-checkbox v-model="configRebootUse" id="configRebootUse" switch size="sm" class="fontSizeDot9">사용</b-form-checkbox>
        </b-form-group>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-4">
          <b-form-checkbox-group v-model="configRebootWeekSelected" :options="configRebootWeekOptions"
            :aria-describedby="ariaDescribedby" plain :disabled="configRebootUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
          <div class="text-right">
            <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configRebootWeekOptions, 'configRebootWeekSelected')">모두 선택</b-button>
            <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configRebootWeekSelected')">선택 취소</b-button>
          </div>
        </b-form-group>

        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group v-model="configRebootHoursSelected" :options="configRebootHoursOptions"
            :aria-describedby="ariaDescribedby" plain :disabled="configRebootUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
          <div class="text-right">
            <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8"  @click="checkAll(configRebootHoursOptions, 'configRebootHoursSelected')">모두 선택</b-button>
            <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configRebootHoursSelected')">선택 취소</b-button>
          </div>
        </b-form-group>
      </b-form>

      <template slot="modal-footer">
        <b-button variant="primary" size="sm" @click="hideModal('configRebootFloat')">
          닫기
        </b-button>
      </template>

    </b-modal>

    <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configSleepSaveFloat"
      tabindex="-1" title="SLEEP 읽기 요일과 시간 설정 (Config Sleep Save)" static
      @show="modalShowFocus" data-nextfocus="configSleepSaveUse" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

      <p class="mb-1 fontSizeDot9 gothic">
        Sleep 모드에서 특정 요일, 시간에 센서를 측정해서 저장할 수 있습니다. 시간이 선택된 경우, Sleep Interval 속성이 600000(10분)이면 0분, 10분, 20분, 30분, 40분, 50분에 센서를 측정해서 저장합니다.
      </p>
      <b-form @submit.stop.prevent class="m-3">

        <b-form-group class="mb-3">
          <b-form-checkbox v-model="configSleepSaveUse" id="configSleepSaveUse" switch size="sm" class="fontSizeDot9">사용</b-form-checkbox>
        </b-form-group>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-4">
          <b-form-checkbox-group v-model="configSleepSaveWeekSelected" :options="configSleepSaveWeekOptions"
            :aria-describedby="ariaDescribedby" plain :disabled="configSleepSaveUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
          <div class="text-right">
            <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configSleepSaveWeekOptions, 'configSleepSaveWeekSelected')">모두 선택</b-button>
            <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepSaveWeekSelected')">선택 취소</b-button>
          </div>
        </b-form-group>

        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group v-model="configSleepSaveHoursSelected" :options="configSleepSaveHoursOptions"
            :aria-describedby="ariaDescribedby" plain :disabled="configSleepSaveUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
          <div class="text-right">
            <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8"  @click="checkAll(configSleepSaveHoursOptions, 'configSleepSaveHoursSelected')">모두 선택</b-button>
            <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepSaveHoursSelected')">선택 취소</b-button>
          </div>
        </b-form-group>
      </b-form>

      <template slot="modal-footer">
        <b-button variant="primary" size="sm" @click="hideModal('configSleepSaveFloat')">
          닫기
        </b-button>
      </template>

    </b-modal>

    <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configSleepUpdateFloat"
      tabindex="-1" title="SLEEP 업데이트 요일과 시간 설정" static
      @show="modalShowFocus" data-nextfocus="configSleepUpdateUse" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

      <p class="mb-1 fontSizeDot9 gothic">
        Sleep 모드에서 특정 요일, 시간에 데이터를 서버로 업로드할 수 있습니다. 여기서 지정한 요일과 시간은 Config Sleep Save 설정에서도 동일한 요일, 시간이 선택된 경우에만 동작합니다. Update Interval 설정으로 지정한 시간대에서 언제 데이터를 업로드할 지도 지정할 수 있습니다.
      </p>
      <b-form @submit.stop.prevent class="m-3">

        <b-form-group class="mb-3">
          <b-form-checkbox v-model="configSleepUpdateUse" id="configSleepUpdateUse" class="fontSizeDot9" switch size="sm">사용</b-form-checkbox>
        </b-form-group>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-4">
          <b-form-checkbox-group v-model="configSleepUpdateWeekSelected" :options="configSleepUpdateWeekOptions" :aria-describedby="ariaDescribedby" plain :disabled="configSleepUpdateUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
          <div class="text-right">
            <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configSleepUpdateWeekOptions, 'configSleepUpdateWeekSelected')">모두 선택</b-button>
            <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepUpdateWeekSelected')">선택 취소</b-button>
          </div>
        </b-form-group>

        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group v-model="configSleepUpdateHoursSelected" :options="configSleepUpdateHoursOptions" class="fontSizeDot9"
            :aria-describedby="ariaDescribedby" plain :disabled="configSleepUpdateUse != '1'"></b-form-checkbox-group>
          <div class="text-right">
            <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configSleepUpdateHoursOptions, 'configSleepUpdateHoursSelected')">모두 선택</b-button>
            <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepUpdateHoursSelected')">선택 취소</b-button>
          </div>
        </b-form-group>
      </b-form>

      <template slot="modal-footer">
        <b-button variant="primary" size="sm" @click="hideModal('configSleepUpdateFloat')">
          닫기
        </b-button>
      </template>

    </b-modal>


  </div>

</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"

import deviceTabs from "@/components/device/deviceTabs.vue"
 
import configStatusInputList from "@/components/common/configStatusInputList.json"

/*
{
    "title":"SD 사용", "id":"sd", "value": "0", "pos": 9, "disabled": true, "details": "사용(1)로 선택하면 SD 기능을 켭니다. Tinkable IoT 키트에 SPI 방식으로 SD 메모리 어댑터를 연결해서 데이터를 저장하는 용도로 사용할 수 있습니다."
},
{
    "title":"바이너리 SD저장", "id":"archiveAsBinary", "value": "0", "pos": 14, "disabled": true, "details": "사용(1)로 선택하면 SD 메모리에 센서 데이터를 저장할 때(Archive) 바이너리 형식으로, 사용안함(0)으로 선택하면 텍스트 형식으로 저장합니다. 바이너리형식으로 저장하면 데이터 저장 공간이 줄어들지만 데이터 파일을 바로 읽을 수 없습니다. 기본값은 사용안함(0)입니다."
},
{
    "title":"설정서버 종료", "id":"endAfterConfig", "value": "1", "pos": 16, "details": "사용(1)로 선택하면 팅커블 IoT 보드의 설정 서버를 실행하여 con.tinkable.net에서 설정을 저장한 경우에 자동으로 설정 서버를 종료합니다. 기본값은 사용(1)입니다."
},
{
    "title":"설정서버 리부팅", "id":"rebootAfterConfig", "value": "1", "pos": 17, "details": "사용(1)로 선택하면 설정서버 종료시 자동으로 팅커블 IoT 보드를 리부팅합니다. 설정 서버는 메모리 누수 가능성이 높아서 불편하더라도 가능한 1로 설정하여 설정서버 종료시 자동으로 리부팅하는 것이 좋습니다."
},
{
    "title":"로고 표시", "id":"showLogo", "value": "1", "pos": 24, "details": "사용(1)으로 지정하면 팅커블 IoT 키트 부팅시에 팅커블 로고를 표시합니다. 기본값은 사용(1)입니다. 로고가 표시될 때 버튼을 누르고 있으면 설정 모드로 들어갑니다."
},
*/


export default {
  name: "deviceConfig",
  mixins: [uiUtil, mapUtil, user],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageBinded: Boolean,
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {
      acode: null,
      wifiNewSSID: "",
      wifiNewPassword: "",
      showSaveSpinner: false,

      week: ["일", "월", "화", "수", "목", "금", "토"],

      configRebootUse: true,
      configRebootWeekSelected: [],
      configRebootWeekOptions: [],
      configRebootHoursSelected: [],
      configRebootHoursOptions: [],

      configSleepSaveUse: true,
      configSleepSaveWeekSelected: [],
      configSleepSaveWeekOptions: [],
      configSleepSaveHoursSelected: [],
      configSleepSaveHoursOptions: [],

      configSleepUpdateUse: true,
      configSleepUpdateWeekSelected: [],
      configSleepUpdateWeekOptions: [],
      configSleepUpdateHoursSelected: [],
      configSleepUpdateHoursOptions: [],

      configJsonDownloadURL: null,

      configStatusInputList: configStatusInputList,
    }
  },

  mounted: function() {

    if(typeof(this.pageDevice.config) == "undefined") this.$set(this.pageDevice, "config", {});
    if(typeof(this.pageDevice.config.ve) == "undefined") this.$set(this.pageDevice.config, "ve", 1);

    // if(typeof(this.pageDevice.config.rb) == "undefined") this.$set(this.pageDevice.config, "rb", 0b10001000000010000000000000000000);
    // if(typeof(this.pageDevice.config.sl) == "undefined") this.$set(this.pageDevice.config, "sl", 0b00000000000000000000000000000000);
    // if(typeof(this.pageDevice.config.su) == "undefined") this.$set(this.pageDevice.config, "su", 0b00000000000000000000000000000000);
    // if(typeof(this.pageDevice.config.st) == "undefined") this.$set(this.pageDevice.config, "st", 0b00000111000110011110101011011111);

    if(typeof(this.pageDevice.config.rb) == "undefined") this.$set(this.pageDevice.config, "rb", "10001000000010000000000000000000");
    if(typeof(this.pageDevice.config.sl) == "undefined") this.$set(this.pageDevice.config, "sl", "00000000000000000000000000000000");
    if(typeof(this.pageDevice.config.su) == "undefined") this.$set(this.pageDevice.config, "su", "00000000000000000000000000000000");
    if(typeof(this.pageDevice.config.st) == "undefined") this.$set(this.pageDevice.config, "st", "00000111000110011110111011011111");

    if(typeof(this.pageDevice.config.id) == "undefined") this.$set(this.pageDevice.config, "id", "");
    if(typeof(this.pageDevice.config.wt) == "undefined") this.$set(this.pageDevice.config, "wt", 3);
    if(typeof(this.pageDevice.config.wi) == "undefined") this.$set(this.pageDevice.config, "wi", 300000);
    if(typeof(this.pageDevice.config.ui) == "undefined") this.$set(this.pageDevice.config, "ui", 120000);
    if(typeof(this.pageDevice.config.sr) == "undefined") this.$set(this.pageDevice.config, "sr", 10000);
    if(typeof(this.pageDevice.config.si) == "undefined") this.$set(this.pageDevice.config, "si", 300000);

    if(typeof(this.pageDevice.wifi) == "undefined") this.$set(this.pageDevice, "wifi", []);

    if(this.pageDevice.config.rb) {
      // let configRebootList = this.pageDevice.config.rb.toString(2).padStart(32, '0').split("");
      let configRebootList = this.pageDevice.config.rb.padStart(32, '0').split("");
      configRebootList.forEach((item,index) => {
        if(index == 0) {
          this.configRebootUse = (item == "0")? false: true;
        }
        else if(index <8) {
          this.configRebootWeekOptions.push({ text: this.week[index-1], value: index });
          if(item == "1") {
            this.configRebootWeekSelected.push(index);
          }
        }
        else {
          this.configRebootHoursOptions.push({ text: (index-8) + "시", value: index });
          if(item == "1") {
            this.configRebootHoursSelected.push(index);
          }
        }
      });
    }

    if(this.pageDevice.config.sl) {
      // let configSleepSaveList = this.pageDevice.config.sl.toString(2).padStart(32, '0').split("");
      let configSleepSaveList = this.pageDevice.config.sl.padStart(32, '0').split("");

      configSleepSaveList.forEach((item,index) => {
        if(index == 0) {
          this.configSleepSaveUse = (item == "0")? false: true;
        }
        else if(index <8) {
          this.configSleepSaveWeekOptions.push({ text: this.week[index-1], value: index });
          if(item == "1") {
            this.configSleepSaveWeekSelected.push(index);
          }
        }
        else {
          this.configSleepSaveHoursOptions.push({ text: (index-8) + "시", value: index });
          if(item == "1") {
            this.configSleepSaveHoursSelected.push(index);
          }
        }
      });
    }  


    if(this.pageDevice.config.su) {
      // let configSleepUpdateList = this.pageDevice.config.su.toString(2).padStart(32, "0").split("");
      let configSleepUpdateList = this.pageDevice.config.su.padStart(32, "0").split("");
      configSleepUpdateList.forEach((item,index) => {
        if(index == 0) {
          this.configSleepUpdateUse = (item == "0")? false: true;
        }
        else if(index <8) {
          this.configSleepUpdateWeekOptions.push({ text: this.week[index-1], value: index });
          if(item == "1") {
            this.configSleepUpdateWeekSelected.push(index);
          }
        }
        else {
          this.configSleepUpdateHoursOptions.push({ text: (index-8) + "시", value: index });
          if(item == "1") {
            this.configSleepUpdateHoursSelected.push(index);
          }
        }
      });
    }  

    if(this.pageDevice.config.st) {
      // let configStatusValues = this.pageDevice.config.st.toString(2).padStart(32, '0').split("");
      let configStatusValues = this.pageDevice.config.st.padStart(32, '0').split("");
      this.configStatusInputList.forEach(item=> {
        if(item.pos < configStatusValues.length) {
          item.value = configStatusValues[item.pos];
        }
      });
    }  

    if(firebase.auth().currentUser != null  && this.isLoginUserPageUser) {
      this.getAcode();
    }

  },
  methods: {
    getAcode: function() {
      db.collection("acodes").where("device", "==", this.pageDevice.id).where("owner", "==", this.pageUser.id)
      .get()
      .then(acodeList => {
        acodeList.forEach(acode => {
          if(acode.exists) {
            // this.serial = acode.data().serial
            this.acode = acode.id
          }
        })
      })
      .catch(error => {
        this.makeToast("danger", "접속 코드 조회 실패", "접속 코드 조회 중에 에러가 발생했습니다. 에러 내용:" + error)
      })
    },
    checkAll: function(list, selected) {
      var newSelected = [];
      list.forEach(item=> {
        newSelected.push(item.value);
      })
      this.$set(this, selected, newSelected);
    },
    uncheckAll: function(selected) {
      this.$set(this, selected, []);
    },
    addNewSSID: function() {
      if(this.pageDevice.wifi.length <= 20) {
        if(this.pageDevice.wifi.every(item => {
          return item.s != this.wifiNewSSID;
        })) {
          let toAdd = {};
          toAdd.s = this.wifiNewSSID;
          if(this.wifiNewPassword.p != "") toAdd.p = this.wifiNewPassword;
          this.pageDevice.wifi.push(toAdd);
          this.wifiNewSSID = "";
          this.wifiNewPassword = "";
        }
        else {
          this.makeToast("danger", "새 SSID 추가 실패", "중복된 이름의 SSID가 이미 있습니다.");
        }
      }
      else {
        this.makeToast("danger", "새 SSID 추가 실패", "최대 5개만 추가 가능합니다.");
      }
    },
    deleteSSID: function(index) {
      this.pageDevice.wifi.splice(index, 1);
    },

    resetDeviceConfig: function() {

      this.$bvModal.msgBoxConfirm("Config를 초기화하면 취소할 수 없습니다. Config를 초기화할까요?", {
        size: "sm",
        buttonSize: "md",
        okVariant: "secondary",
        okTitle: "Config 초기화하기",
        cancelTitle: "취소",
        cancelVariant: "danger",
        bodyClass: "gothic",
        footerClass: "p-1 pr-3",
        hideHeaderClose: true,
      })
      .then(confirmed => {
        if(confirmed) {
          this.$set(this.pageDevice, "config", {});
          this.$set(this.pageDevice.config, "ve", 0);
          this.$set(this.pageDevice.config, "rb", "10001000000010000000000000000000");
          this.$set(this.pageDevice.config, "sl", "00000000000000000000000000000000");
          this.$set(this.pageDevice.config, "su", "00000000000000000000000000000000");
          this.$set(this.pageDevice.config, "st", "00000111000110011110111011011111");
          this.$set(this.pageDevice.config, "id", "");
          this.$set(this.pageDevice.config, "wt", 3);
          this.$set(this.pageDevice.config, "wi", 300000);
          this.$set(this.pageDevice.config, "ui", 120000);
          this.$set(this.pageDevice.config, "sr", 60000);
          this.$set(this.pageDevice.config, "si", 600000);

          /*
          unsigned long int _configStatus = 0b00000111000110011110101011011111;
          unsigned long int _sleepInterval = TK_SLEEP_INTERVAL;
          unsigned long int _sleepReadDelay = TK_DEEP_SLEEP_READ_DELAY;
          unsigned long int _configReboot = 0b10001000000010000000000000000000;
          unsigned long int _configSleepSave = 0b00000000000000000000000000000000;
          unsigned long int _configSleepUpdate = 0b00000000000000000000000000000000;
          */

          this.pageDevice.wifi.splice(0);

          this.configRebootWeekOptions.splice(0);
          this.configRebootWeekSelected.splice(0);
          this.configRebootHoursOptions.splice(0);
          this.configRebootHoursSelected.splice(0);

          this.configSleepSaveWeekOptions.splice(0);
          this.configSleepSaveWeekSelected.splice(0);
          this.configSleepSaveHoursOptions.splice(0);
          this.configSleepSaveHoursSelected.splice(0);

          this.configSleepUpdateWeekOptions.splice(0);
          this.configSleepUpdateWeekSelected.splice(0);
          this.configSleepUpdateHoursOptions.splice(0);
          this.configSleepUpdateHoursSelected.splice(0);

          // let configStatusValues = this.pageDevice.config.st.toString(2).padStart(32, '0').split("");
          let configStatusValues = this.pageDevice.config.st.padStart(32, '0').split("");

          this.configStatusInputList.forEach(item=> {
            if(item.pos < configStatusValues.length) {
              item.value = configStatusValues[item.pos];
            }
          });

          // let configRebootList = this.pageDevice.config.rb.toString(2).padStart(32, '0').split("");
          let configRebootList = this.pageDevice.config.rb.padStart(32, '0').split("");

          configRebootList.forEach((item,index) => {
            if(index == 0) {
              this.configRebootUse = (item == "0")? false: true;
            }
            else if(index <8) {
              this.configRebootWeekOptions.push({ text: this.week[index-1], value: index });
              if(item == "1") {
                this.configRebootWeekSelected.push(index);
              }
            }
            else {
              this.configRebootHoursOptions.push({ text: (index-8) + "시", value: index });
              if(item == "1") {
                this.configRebootHoursSelected.push(index);
              }
            }
          });

          // let configSleepSaveList = this.pageDevice.config.sl.toString(2).padStart(32, '0').split("");
          let configSleepSaveList = this.pageDevice.config.sl.padStart(32, '0').split("");

          configSleepSaveList.forEach((item,index) => {
            if(index == 0) {
              this.configSleepSaveUse = (item == "0")? false: true;
            }
            else if(index <8) {
              this.configSleepSaveWeekOptions.push({ text: this.week[index-1], value: index });
              if(item == "1") {
                this.configSleepSaveWeekSelected.push(index);
              }
            }
            else {
              this.configSleepSaveHoursOptions.push({ text: (index-8) + "시", value: index });
              if(item == "1") {
                this.configSleepSaveHoursSelected.push(index);
              }
            }
          });


          // let configSleepUpdateList = this.pageDevice.config.su.toString(2).padStart(32, "0").split("");
          let configSleepUpdateList = this.pageDevice.config.su.padStart(32, "0").split("");

          configSleepUpdateList.forEach((item,index) => {
            if(index == 0) {
              this.configSleepUpdateUse = (item == "0")? false: true;
            }
            else if(index <8) {
              this.configSleepUpdateWeekOptions.push({ text: this.week[index-1], value: index });
              if(item == "1") {
                this.configSleepUpdateWeekSelected.push(index);
              }
            }
            else {
              this.configSleepUpdateHoursOptions.push({ text: (index-8) + "시", value: index });
              if(item == "1") {
                this.configSleepUpdateHoursSelected.push(index);
              }
            }
          });

          this.saveDeviceConfig(false);

        }
      });
    },

    createConfigJson: function() {
      let configJsonFile = new Blob([JSON.stringify(this.pageDevice.config)], {
        type: "text/plain;charset=utf-8"
      });

      if(this.configJsonDownloadURL != null) {
        URL.revokeObjectURL(this.configJsonDownloadURL);
        this.configJsonDownloadURL = null;
      }
      this.configJsonDownloadURL = URL.createObjectURL(configJsonFile);
    },

    saveDeviceConfig: function(versionUp=true) {

      if(versionUp) {
        this.pageDevice.config.ve += ((this.pageDevice.config.ve*1)%2 == 0)? 2: 1;
      }

      this.pageDevice.config.ac = this.acode;

      /*
      this.pageDevice.config.st = parseInt(this.configStatusBinary, 2);
      this.pageDevice.config.su = parseInt(this.configSleepUpdateBinary, 2);
      this.pageDevice.config.rb = parseInt(this.configRebootBinary, 2);
      this.pageDevice.config.sl = parseInt(this.configSleepSaveBinary, 2);
      */

      this.pageDevice.config.st = this.configStatusBinary;
      this.pageDevice.config.su = this.configSleepUpdateBinary;
      this.pageDevice.config.rb = this.configRebootBinary;
      this.pageDevice.config.sl = this.configSleepSaveBinary;

      if(this.pageDevice.disabled) {
        this.makeToast("danger", "[" + this.pageDevice.name + "] 기기 정보 수정 실패", "정지 중인 기기는 수정할 수 없습니다.");
        return false;
      }

      if(!window.document.getElementById('formData').checkValidity()) {
        window.document.getElementById('formData').reportValidity();
        return false;
      }

      this.showUpdateSpinner = true;

      db.collection("devices").doc(this.pageDevice.id).update({
        config: this.pageDevice.config,
        wifi: this.pageDevice.wifi,
        lastModified: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(()=>{
        this.showUpdateSpinner = false
        this.makeToast("success", "[" + this.pageDevice.name + "] 기기 설정 수정 성공", "기기 설정을 변경했습니다.")
      })
      .catch(error => {
        this.showUpdateSpinner = false
        this.makeToast("danger", "[" + this.pageDevice.name + "] 기기 설정 수정 실패", "다음과 같은 에러가 발생했습니다.\n에러 내용:" + error.message)
      })

    }
  },
  computed: {

    configJsonSource: function() {
      return JSON.stringify(this.pageDevice.config, null, '\t');
    },

    configStatusBinary: function() {
      let resultList = "".padStart(32, '0').split("");
      this.configStatusInputList.forEach(item => {
        if(item.value == "1") {
          this.$set(resultList, item.pos, "1");
        }
        else {
          this.$set(resultList, item.pos, "0");
        }
      });
      return resultList.join("");
    },

    configRebootBinary: function() {
      let resultList = "".padStart(32, '0').split("");
      if(this.configRebootUse) {
        resultList[0] = "1";
      }
      this.configRebootWeekSelected.forEach(item => {
        resultList[item] = "1";
      });
      this.configRebootHoursSelected.forEach(item => {
        resultList[item] = "1";
      });
      return resultList.join("");
    },

    configSleepSaveBinary: function() {
      let resultList = "".padStart(32, '0').split("");
      if(this.configSleepSaveUse) {
        resultList[0] = "1";
      }
      this.configSleepSaveWeekSelected.forEach(item => {
        resultList[item] = "1";
      });
      this.configSleepSaveHoursSelected.forEach(item => {
        resultList[item] = "1";
      });
      return resultList.join("");
    },

    configSleepUpdateBinary: function() {
      let resultList = "".padStart(32, '0').split("");
      if(this.configSleepUpdateUse) {
        resultList[0] = "1";
      }
      this.configSleepUpdateWeekSelected.forEach(item => {
        resultList[item] = "1";
      });
      this.configSleepUpdateHoursSelected.forEach(item => {
        resultList[item] = "1";
      });
      return resultList.join("");
    },
  },
}
</script>
